
import BaseTable, {AutoResizer, SortOrder} from 'react-base-table'
import React, {useEffect, useState} from 'react';
import 'react-base-table/styles.css'
import './base-table.css'
import styled from 'styled-components';

//NSN Sample Options
//5945007525599
//5945009027323

const DocumentTable = ({nsnData}) => {

    
    const [data, setData] = useState({});
    const [sortBy, setSortBy] = useState({
        key: 'awardDate', 
        order: SortOrder.ASC
    })
    
    useEffect(() => {

        const dollar = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

        setData(nsnData.map((doc, index) => {
            return {
                vendor: doc.vendor_name,
                cage: doc.cage,
                contractNumber: doc.contract_number,
                poItmno: doc.po_itmno,
                nsn: doc.nsn,
                awardDate: doc.award_date,
                orderQty: doc.order_qty,
                netPrice: doc.netprice,
                id: 'row-' + index,
                totalAward: dollar.format(doc.order_qty * doc.netprice)

            }
        }));
    }, [nsnData])

    console.log(data)

    const onSort = (key, order) => {
        setSortBy({
            key: key, 
            order: order
        })
        sortHelper(key, order);
    }

    const sortHelper = (colKey, order) => {
        if (colKey === 'partNumber') {
            setData(data.sort((a, b) => {
                const nameA = a[colKey].toLowerCase();
                const nameB = b[colKey].toLowerCase();
                    if (nameA < nameB) return order === SortOrder.ASC ? -1 : 1;
                    if (nameA > nameB) return order === SortOrder.ASC ?  1 : -1;
                    return 0;
                })
            );
        }
            
    }

    const columns = [
        {
            key: 'vendor',
            dataKey: 'vendor',
            title: 'Vendor',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },
        
        {
            key: 'cage',
            dataKey: 'cage',
            title: 'Cage',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },
         {
            key: 'contractNumber',
            dataKey: 'contractNumber',
            title: 'Contract Number',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: true
        },
        {
            key: 'poItmno',
            dataKey: 'poItmno',
            title: 'PO Item',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: true
        },
         {
            key: 'nsn',
            dataKey: 'nsn',
            title: 'NSN',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: true
        },
        {
            key: 'awardDate',
            dataKey: 'awardDate',
            title: 'Award date',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: true
        },
         {
            key: 'orderQty',
            dataKey: 'orderQty',
            title: 'Order Qty',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: true
        },
         {
            key: 'netPrice',
            dataKey: 'netPrice',
            title: 'NetPrice',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: true
        },
        {
            key: 'totalAward',
            dataKey: 'totalAward',
            title: 'Total Award',
            width: 200,
            align: 'center',
            resizable: true,
            sortable: true
        }
    ]

    const Container = styled.div`
        width: calc(50vw + 220px);
        height: 50vh;
        `

    return (
    <>
        <Container>
            <AutoResizer>
                {({ width, height }) => (
                    <BaseTable
                        className='base-table'
                        width={width}
                        height={height}
                        columns={columns}
                        data={data}
                        sortBy={sortBy}
                        onColumnSort={({key, order}) => onSort(key, order)}
                    />
                )}
            </AutoResizer>
        </Container>
    </>
    );
}

export default DocumentTable